module.exports = __webpack_public_path__ + "img/player_control.9888b19f.png";